export function Logo({
	size = 30,
	className,
}: {
	size?: number;
	className?: string;
}) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 734 734"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={`overflow-visible ${className}`}
		>
			<path
				d="M708.333 708.333L480.778 480.778M25.6667 291.148C25.6667 326.012 32.5336 360.534 45.8753 392.744C59.217 424.953 78.7722 454.22 103.424 478.872C128.077 503.524 157.343 523.079 189.553 536.421C221.763 549.763 256.285 556.63 291.148 556.63C326.012 556.63 360.534 549.763 392.744 536.421C424.953 523.079 454.22 503.524 478.872 478.872C503.524 454.22 523.079 424.953 536.421 392.744C549.763 360.534 556.63 326.012 556.63 291.148C556.63 256.285 549.763 221.762 536.421 189.553C523.079 157.343 503.524 128.077 478.872 103.424C454.22 78.7722 424.953 59.2169 392.744 45.8752C360.534 32.5335 326.012 25.6667 291.148 25.6667C256.285 25.6667 221.763 32.5335 189.553 45.8752C157.343 59.2169 128.077 78.7722 103.424 103.424C78.7722 128.077 59.217 157.343 45.8753 189.553C32.5336 221.762 25.6667 256.285 25.6667 291.148Z"
				stroke="currentColor"
				strokeWidth="70"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M367 177.37H272.185C257.097 177.37 242.627 183.364 231.959 194.033C221.29 204.701 215.296 219.171 215.296 234.259C215.296 249.347 221.29 263.817 231.959 274.486C242.627 285.155 257.097 291.148 272.185 291.148H310.111C325.199 291.148 339.669 297.142 350.338 307.811C361.006 318.479 367 332.949 367 348.037C367 363.125 361.006 377.595 350.338 388.264C339.669 398.932 325.199 404.926 310.111 404.926H215.296M291.148 404.926V442.852M291.148 139.444V177.37"
				stroke="currentColor"
				strokeWidth="60"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
